import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';

async function fetchList() {

  return await _setAxios("tahun-ajaran/tahun", "GET")
    .then(body => {
      let results = []
      body.data.data.forEach(row => {

        results.push({
          label: row.tahun_ajaran,
          value: row.id,
        })
      });

      return results
    })
}

const SelectTahunAjaran = ({ ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
    });
  }, []);

  return (
    <Select
      {...props}
      placeholder="Pilih tahun ajaran"
      fetchOptions={fetchList}
      style={{
        width: '100%',
      }}
      options={options}
    />
  );
};
export default SelectTahunAjaran;
